import useRecaptchaV3 from './useRecaptchaV3';

export { ZolaRecaptchaV3Actions } from './useRecaptchaV3';
export default useRecaptchaV3;
